module.exports = __webpack_public_path__ + "pc/img/fj.d58f938a.png";